// src/components/admin/AgentDashboard.js

import React from "react";
import { useNavigate } from "react-router-dom";
import ConversationList from "./ConversationList";
import ActiveChatWindow from "./ActiveChatWindow"; // We'll create this next
import { useAgentChat } from "../../hooks/useAgentChat";
import "./AgentDashboard.css";
import logo from "../../assets/fitoja-logo.jpg";

const AgentDashboard = () => {
  // Use the hook to manage connection and active chat state
  const {
    activeConversation,
    messages,
    claimAndJoinChat,
    sendMessage,
    setActiveConversation,
    setMessages, // <--- ADDED THIS!
    joinChatRoom,
  } = useAgentChat();

  const navigate = useNavigate();

  // Handler passed to the ConversationList
  const handleSelectConversation = (conversation) => {
    // If the chat is 'Open', claim it immediately.
    if (conversation.status === "Open") {
      claimAndJoinChat(conversation);
    } else {
      // 💡 FIX: For already assigned chats, just set active and join the room.
      setActiveConversation(conversation);
      joinChatRoom(conversation.roomId); // Call the new function
    }
  };

  // Simple handler to close the chat view
  const handleCloseChat = () => {
    setActiveConversation(null);
    setMessages([]); // Clear messages when closing
  };

  return (
    <div className="agent-dashboard">
      <div style={{display: "flex"}}>
        <div className="logo" onClick={() => navigate("/dashboard")}>
          <img src={logo} />
        </div>
        <h1 className="dashboard-title">Live Chat</h1>
      </div>

      <div className="dashboard-layout">
        {/* Panel 1: List of Active Conversations */}
        <div className="list-panel">
          <ConversationList onSelectConversation={handleSelectConversation} />
        </div>

        {/* Panel 2: Active Chat Window */}
        <div className="chat-panel">
          {activeConversation ? (
            <ActiveChatWindow
              conversation={activeConversation}
              messages={messages}
              sendMessage={sendMessage}
              onClose={handleCloseChat}
            />
          ) : (
            <div className="chat-placeholder">
              Select a conversation from the list to start chatting.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AgentDashboard;
